import React from 'react'
import { Link } from 'react-router-dom'
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import styled from "styled-components";

const TooltipText = ({ milestones }) => {
    const renderedMilestones = milestones.map((entry, index) => {
        const { name, approved, link } = entry
        return (<TooltipRow key={index}>
            {approved ?
                (<><div><CheckCircleTwoTone twoToneColor="#0F0" /></div><Link to={`/${link}`}>{name}</Link></>) :
                (<><div><CloseCircleTwoTone twoToneColor="#F00" /></div><Link to={`/${link}`}>{name}</Link></>)
            }
        </TooltipRow>)
    })
    return (
        <TooltipContainer>
            <div>Completed</div>
            {renderedMilestones}
        </TooltipContainer>
    )
}

export default TooltipText

const TooltipContainer = styled.div`
    min-width:100px;
`


const TooltipRow = styled.div`
    display:flex;
    div,span{
        padding:2px;
    }
    a{
        padding:2px;
        text-decoration:none;
    }
    // justify-content:space-between;
`